<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

// Components
import Icon from "@/Components/Icon.vue";

// Icons
import search from "@i/search-icon.svg";
import location from "@i/location-icon.svg";
import hand from "@i/hand-icon.svg";

const route = inject("route");
const { t } = useI18n();
</script>

  <template>
  <div class="section-container">
    <div class="grid md:grid-cols-2 gap-8 items-center">
      <!-- Left Content -->
      <div>
        <h2 class="text-4xl md:text-5xl">{{ $t('Snel en efficiënt op zoek naar de juiste match') }}</h2>

        <!-- Two Columns with Two Items in the Left Column and One Below -->
        <div class="mt-6 grid md:grid-cols-2 gap-6">
          <!-- Snell -->
          <div class="items-start space-x-4">
            <Icon :icon="search" class="w-10 mb-4 ml-4" />
            <div>
              <h3 class="text-xl font-semibold">{{ $t('Snel') }}</h3>
              <p
                class="mt-2 text-lg"
              >{{ $t('Met ons online platform kunt u snel en efficiënt zoeken naar de juiste zorgprofessional voor uw specifieke behoeften.') }}</p>
            </div>
          </div>

          <!-- Efficiënt -->
          <div class="items-start space-x-4">
            <Icon :icon="location" class="w-10 mb-4 ml-4" />
            <div>
              <h3 class="text-xl font-semibold">{{ $t('Efficiënt') }}</h3>
              <p
                class="mt-2 text-lg"
              >{{ $t('Wij helpen u om tijd te besparen door de juiste kandidaten voor u te selecteren.') }}</p>
            </div>
          </div>

          <!-- Match - Takes full width under the first two columns -->
          <div class="items-start space-x-4 md:col-span-2">
            <Icon :icon="hand" class="w-10 mb-4 ml-4" />
            <div>
              <h3 class="text-xl font-semibold">{{ $t('Match') }}</h3>
              <p
                class="mt-2 text-lg"
              >{{ $t('Wij zorgen voor een goede match tussen de zorginstelling en de zorgprofessional, zodat u altijd de beste zorg kunt bieden.') }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Image -->
      <div class="flex justify-center">
        <img
          src="@/../img/home/google-map.jpg"
          alt="Match Platform"
          class="max-w-full rounded-lg shadow-md"
        />
      </div>
    </div>
  </div>
</template>